import {createContext} from 'react';

export interface AuthContextType {
    onAuth: (message?: string) => void;
    needAuth: boolean;
}

export const defaultAuth = {
    onAuth: () => console.log("not implemented"),
    needAuth: true
}

export const AuthContext = createContext<AuthContextType>(defaultAuth);
